import { Link } from "react-router-dom";

export const HowItWorksSection = () => {
  return (
    <section className="mt-20 mb-16 bg-muted/30 rounded-2xl p-8">
      <h2 className="text-3xl font-bold text-center mb-12">
        How Our <strong>Best AI Humanizer</strong> Works
      </h2>
      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 text-primary-foreground font-bold text-xl">
            1
          </div>
          <h3 className="text-lg font-semibold mb-3">Paste Your AI Text</h3>
          <p className="text-muted-foreground">
            Simply paste your AI-generated content into our <strong>free AI text humanizer</strong> input field. Works with ChatGPT, Bard, Claude, and all AI tools.
          </p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 text-primary-foreground font-bold text-xl">
            2
          </div>
          <h3 className="text-lg font-semibold mb-3">AI Processing</h3>
          <p className="text-muted-foreground">
            Our advanced algorithms analyze and transform your text to sound naturally human. The <strong>best AI humanizer</strong> technology at work.
          </p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 text-primary-foreground font-bold text-xl">
            3
          </div>
          <h3 className="text-lg font-semibold mb-3">Get Human-Like Text</h3>
          <p className="text-muted-foreground">
            Receive naturally flowing, engaging content that passes AI detection tools. <Link to="/humanize-ai-text-online" className="text-primary hover:underline"><strong>Humanize AI text online</strong></Link> instantly!
          </p>
        </div>
      </div>
    </section>
  );
};